import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { SelectValueAccessorDirective, ValidateDirective } from '@skylab-angular-shared/ui';
import { FiscalDeviceVatRatesParametersMappingModelWrapper } from '../../fiscal-device-dialog-grid-item';

@Component({
    selector: 'skl-fiscal-device-dialog-grid-vat-rate-id',
    template: `
    <ins-form-field
        class="no-boundary grid-cell-ins-component">
        <ins-select
            display-text="symbol"
            [converter]="entity.vatRatesConverter"
            [placeholder]="'scenes.configuration.shared.fiscalization.dialog.grid.columns.system-vat-rate.placeholder'|translate"
            [(ngModel)]="entity.model.vatRateId"
            [sklValidate]="'vatRateId.' + entity.model.sun">
            <ins-option
                [value]="null">
                {{'ui.placeholders.empty' | translate}}
            </ins-option>
            @for (item of entity.vatRates; track item) {
                <ins-option
                    [value]="item">
                    {{item.symbol}}
                </ins-option>
            }
        </ins-select>
    </ins-form-field>`,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [SelectValueAccessorDirective, FormsModule, ValidateDirective, TranslatePipe]
})
export class FiscalDeviceDialogGridVatRateId {
    @Input() public entity!: FiscalDeviceVatRatesParametersMappingModelWrapper;
}
